var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.994 0C9.654 0 10.998 1.34 11 3H9c0-.506-.387-.934-.886-.993L7.997 2H3.003A.99.99 0 0 0 2 2.995v8.01c0 .54.449.995 1.003.995h4.994A.99.99 0 0 0 9 11.005V11h2l-.005.173a3.007 3.007 0 0 1-3 2.827h-4.99A3.003 3.003 0 0 1 0 10.997V3.003A3.007 3.007 0 0 1 3.006 0zm4.895 3.69.55.53 1.944 1.875h.589l-.001.012.01-.004v1.869l-.598-.067L13.44 9.78l-.55.53-1.1-1.06.55-.53.745-.72H9V6h4.085l-.746-.72-.55-.53z"
})));
export default SvgSignOut;